import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import CardCarousel from 'components/consumer/image-slider-standard/components/CardCarousel';
import { fetchPostsByCategory } from 'lib/contentful-client';
import ToggleCTALinkButton from 'components/essentials/ToggleCTALinkButton';
import AdminPlaceholder from 'components/consumer/AdminPlaceholder';
import classNames from 'classnames';
import BlogSlideComponent from './BlogSlideComponent';
const blogUrl = '/blog/';
const ConsumerBlogSliderInner = t0 => {
  const $ = _c(19);
  const {
    config,
    isAdmin
  } = t0;
  const {
    toggleInputType,
    textContentSection,
    backgroundSelection,
    imageComponent
  } = config;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [blogs, setBlogs] = useState(t1);
  const layoutSize = imageComponent?.size ?? "Full Width";
  const textOrientation = textContentSection?.textOrientation?.toLowerCase() ?? "center";
  const titleSize = textContentSection?.title?.size ?? "text-2xl";
  const bodySize = textContentSection?.body?.size ?? "text-base";
  const textColor = textContentSection?.textColor ?? "black";
  const backgroundColor = backgroundSelection?.backgroundColor ?? "#FFFFFF";
  const titleText = textContentSection?.title?.text ?? "";
  const bodyText = textContentSection?.body?.text ?? "";
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      id: ""
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const elementAttribute = t2;
  const TitleTag = textContentSection?.title?.tag || "h1";
  const BodyTag = textContentSection?.body?.tag || "h2";
  let t3;
  let t4;
  if ($[2] !== isAdmin) {
    t3 = () => {
      if (isAdmin) {
        return;
      }
      fetchPostsByCategory(blogUrl, "the-latest", 20, 0, "fields.slug,fields.title,fields.featuredImage").then(result => {
        if (result?.posts && Array.isArray(result.posts) && result.posts.length > 0) {
          const posts = result.posts.map(_temp);
          setBlogs(posts);
        } else {
          setBlogs([]);
        }
      }).catch(() => {
        setBlogs([]);
      });
    };
    t4 = [isAdmin];
    $[2] = isAdmin;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  if (isAdmin) {
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <AdminPlaceholder className="!min-h-[500px]">Consumer Blog Slide: Contentful API Blog Component Placeholder for Variant Builder. <br />The component will display correctly in Consumer</AdminPlaceholder>;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    return t5;
  }
  let t5;
  if ($[6] !== blogs) {
    t5 = blogs.map(_temp2);
    $[6] = blogs;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const children = t5;
  const t6 = "min-h-[440px] mx-0 mt-6 [&_a]:no-underline [&_p]:text-lg [&_p]:text-gray [&_p]:mt-[22px] [&_p]:mb-6 [&_.slider-control-centerright]:!top-[35%] [&_.slider-control-centerleft]:!top-[35%] [&_.slider-control-centerleft]:!left-[3px] [&_.slider-control-centerright]:!right-[3px]";
  const t7 = backgroundColor ?? "";
  let t8;
  if ($[8] !== t7) {
    t8 = {
      backgroundColor: t7
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = (titleText || bodyText) && <div className={classNames("w-full flex justify-center", {
    "px-5 md:px-[3.333vw] min-[1500px]:px-[50px]": true && layoutSize === "Full Page",
    "items-start": textOrientation.startsWith("top"),
    "items-center": textOrientation.startsWith("center") || textOrientation.startsWith("right") || textOrientation.startsWith("left"),
    "items-end": textOrientation.startsWith("bottom"),
    "text-center justify-items-center": textOrientation.endsWith("center"),
    "text-left justify-items-start": textOrientation.endsWith("left"),
    "text-right justify-items-end": textOrientation.endsWith("right")
  })}><div id={elementAttribute?.id ?? ""} className={classNames("text-gray md:mx-auto md:mb-0", {
      "mt-[30px] px-5 md:px-[3.333vw] min-[1500px]:px-[50px] pt-5 md:pt-[3.333vw] min-[1500px]:pt-[50px]": true,
      "px-0 py-0": false,
      "w-full": layoutSize === "Full Width" || false,
      "max-w-[1400px]": layoutSize === "Full Page" && false,
      "w-full sm:w-[1400px]": layoutSize === "Full Page" && true,
      "!flex-row": textOrientation !== "right",
      "content-start": textOrientation === "left",
      "flex-row-reverse": textOrientation === "right",
      "items-start": textOrientation === "top-left",
      "items-start flex-row-reverse": textOrientation === "top-right",
      "items-start justify-center": textOrientation === "top-center",
      "items-end": textOrientation === "bottom-left",
      "items-end flex-row-reverse": textOrientation === "bottom-right",
      "items-end justify-center": textOrientation === "bottom-center",
      "justify-center": textOrientation === "center"
    })}>{titleText && <TitleTag className={classNames("text-3xl font-bold mb-5 md:mb-[30px]", {
        "text-3xl font-bold": titleSize === "text-3xl",
        "text-[clamp(1.75rem,5.2vw,2.5rem)] leading-[clamp(2.25rem,6.25vw,3rem)] tracking-[.0125rem] font-bold": titleSize === "text-4xl",
        "text-xs": titleSize === "text-xs",
        "text-sm": titleSize === "text-sm",
        "text-base": titleSize === "text-base",
        "text-lg": titleSize === "text-lg",
        "text-xl": titleSize === "text-xl",
        "text-2xl": titleSize === "text-2xl"
      })} style={{
        color: textColor ?? ""
      }}>{titleText}</TitleTag>}{bodyText && <BodyTag className={classNames("text-base [&_a]:font-bold [&_ul]:list-disc [&_ol]:list-[auto] [&_ul]:list-inside [&_ol]:list-inside [&_ul]:pl-4 [&_ol]:pl-4", {
        "text-xs": bodySize === "text-xs",
        "text-sm": bodySize === "text-sm",
        "text-base": bodySize === "text-base",
        "text-lg": bodySize === "text-lg",
        "text-xl": bodySize === "text-xl",
        "text-2xl": bodySize === "text-2xl",
        "text-3xl": bodySize === "text-3xl"
      })} style={{
        color: textColor ?? ""
      }} dangerouslySetInnerHTML={{
        __html: bodyText
      }} />}</div></div>;
  let t10;
  if ($[10] !== children) {
    t10 = <CardCarousel imageHeight={340} imageWidth={340} navType="Button" variant="blog-slider" visibleSlides={4}>{children}</CardCarousel>;
    $[10] = children;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== toggleInputType) {
    t11 = !!toggleInputType && <div className="max-[767px]:pl-5 max-[767px]:pr-5 w-full flex flex-row justify-center my-4"><ToggleCTALinkButton toggleInputType={toggleInputType} noHorizontalPadding={true} /></div>;
    $[12] = toggleInputType;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11 || $[16] !== t8 || $[17] !== t9) {
    t12 = <div className={t6} style={t8}>{t9}{t10}{t11}</div>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t8;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  return t12;
};
const ConsumerBlogSlider = t0 => {
  const $ = _c(4);
  const {
    config,
    isAdmin
  } = t0;
  const layoutSize = config?.imageComponent?.size ?? "Full Width";
  let t1;
  if ($[0] !== config || $[1] !== isAdmin || $[2] !== layoutSize) {
    t1 = layoutSize === "Full Width" ? <div className="w-full overflow-x-hidden"><ConsumerBlogSliderInner config={config} isAdmin={isAdmin} /></div> : <FixedWidthContainer noMobilePadding={true}><ConsumerBlogSliderInner config={config} isAdmin={isAdmin} /></FixedWidthContainer>;
    $[0] = config;
    $[1] = isAdmin;
    $[2] = layoutSize;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default ConsumerBlogSlider;
function _temp(post) {
  return {
    title: post.title,
    slug: post.slug,
    image: `https:${post.featuredImage.fields.file.url.replace("downloads.ctfassets.net", "images.ctfassets.net")}`
  };
}
function _temp2(blog) {
  return <BlogSlideComponent image={blog.image} title={blog.title} key={blog.slug} link={`${blog.slug}`} />;
}